// MSAL wrapper with regular imports
import { PublicClientApplication } from '@azure/msal-browser';

interface MSALConfig {
  auth: {
    clientId: string;
    tenantId: string;
    authority: string;
    redirectUri: string;
  };
  cache: {
    cacheLocation: 'localStorage';
    storeAuthStateInCookie: boolean;
  };
}

// Minimal interface to avoid MSAL type issues
interface MSALInstance {
  initialize(): Promise<void>;
  handleRedirectPromise(): Promise<{ idToken?: string } | null>;
  loginRedirect(options: {
    scopes: string[];
    prompt: string;
    authority: string;
    redirectUri: string;
  }): Promise<void>;
}

class MSALWrapper {
  private static instance: MSALInstance | null = null;

  static getInstance(config: MSALConfig): MSALInstance {
    if (!this.instance) {
      this.instance = new PublicClientApplication(config);
    }

    return this.instance;
  }
}

export { MSALWrapper, type MSALConfig };
